import { useEffect, useState } from "react";
import { useNavigate, } from "react-router-dom";
import api from "@api";
import './ClaimLeagueModal.css'

function ClaimLeagueModal({ directoryLeagueId, onClose, onSuccess }) {
 const navigate = useNavigate();
 const [message, setMessage] = useState("");
 const [submitting, setSubmitting] = useState(false);
 const [checkingAuth, setCheckingAuth] = useState(true);
 const [isAuthed, setIsAuthed] = useState(false);
 const [fullName, setFullName] = useState("");
 const [roleTitle, setRoleTitle] = useState("");
 const [contactEmail, setContactEmail] = useState("");
 const [confirmed, setConfirmed] = useState(false);
 const [error, setError] = useState("");

 useEffect(() => {
  const checkAuth = async () => {
   try {
    const res = await api.get("/api/auth/check-auth", {
     withCredentials: true,
    });

    if (res.data?.authenticated) {
     setIsAuthed(true);
    } else {
     setIsAuthed(false);
    }

   } catch (err) {
    setIsAuthed(false);
   } finally {
    setCheckingAuth(false);
   }
  };

  checkAuth();
 }, []);


 const submitClaim = async () => {
  if (!fullName.trim()) {
   setError("Full name is required.");
   return;
  }

  if (!roleTitle.trim()) {
   setError("Role is required.");
   return;
  }

  if (!contactEmail.trim()) {
   setError("Business email is required.");
   return;
  }

  if (!confirmed) {
   setError("You must confirm authorization.");
   return;
  }

  setError("");
  setSubmitting(true);

  await api.post(
   `/api/directory-league-claims/${directoryLeagueId}/claim`,
   {
    full_name: fullName,
    role_title: roleTitle,
    contact_email: contactEmail,
    message,
    confirmed_authorization: confirmed,
   },
   { withCredentials: true }
  );

  setSubmitting(false);

  window.dispatchEvent(new Event("refresh-notifications")); // 🔔 update bell

  onSuccess?.();   // refresh league page state
  onClose();

  alert("Claim submitted. Pending review.");
 };

 if (checkingAuth) return null;

 if (!isAuthed) {
  return (
   <div className="claim-modal-backdrop">
    <div className="claim-modal">
     <h3>Claim this league</h3>
     <p>You need an account to claim this league.</p>

     <div className="claim-modal-actions">
      <button
       onClick={() => {
        onClose();
        navigate("/login", {
         state: { returnTo: `/directory/leagues/${directoryLeagueId}` },
        });
       }}
      >
       Log in
      </button>

      <button
       onClick={() => {
        onClose();
        navigate("/register", {
         state: { returnTo: `/directory/leagues/${directoryLeagueId}` },
        });
       }}
      >
       Create account
      </button>

     </div>
    </div>
   </div>
  );
 }

 return (
  <div className="claim-modal-backdrop">
   <div className="claim-modal">
    <h3>Claim this organization</h3>
    {error && <div className="claim-alert">{error}</div>}
    <input
     type="text"
     placeholder="Full Name"
     value={fullName}
     onChange={(e) => {
      setFullName(e.target.value);
      setError("");
     }}
    />
    <input
     type="text"
     placeholder="Your Role (Owner, Director, Coach, etc.)"
     value={roleTitle}
     onChange={(e) => {
      setRoleTitle(e.target.value);
      setError("");
     }}
    />
    <input
     type="email"
     placeholder="Business Email"
     value={contactEmail}
     onChange={(e) => {
      setContactEmail(e.target.value);
      setError("");
     }}
    />
    <p className="claim-note">
     We may contact you at this email to verify your authorization to manage this organization.
    </p>
    <textarea
     placeholder="Optional: Brief explanation of your relationship to this organization"
     value={message}
     onChange={(e) => {
      setMessage(e.target.value);
      setError("");
     }}
    />

    <label className="claim-checkbox">
     <input
      type="checkbox"
      checked={confirmed}
      onChange={(e) => {
       setConfirmed(e.target.checked);
      }}
     />

     I confirm I am authorized to manage this organization.
    </label>
    <div className="claim-modal-actions">
     <button onClick={onClose}>Cancel</button>
     <button
      onClick={submitClaim}
      disabled={
      submitting
      }
     >
      Submit
     </button>
    </div>
   </div>
  </div>
 );

}

export default ClaimLeagueModal;
